import axios from '../axiosHelper';
import Cookies from "js-cookie"

export default {
    state: {
        status: '',
        status_code: '',
        message: '',
        message_code: '',
        materiList : [{}],
    },
    getters: {
        getMateriList: state => state.materiList,
    },
    mutations: {
        request(state){
            state.status = 'LOADING'
        },
        success(state, { resp }){
            state.status = 'SUCCESS'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        error(state, { resp }){
            state.status = 'ERROR'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        setMateriList(state, { resp }){
            if (resp) {
                state.materiList = resp.data.data
            }
        },
    },
    actions: {
        addMateri({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/modul/add?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        updateMateri({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/modul/edit?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        addComment({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/modul-comment/add?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        addReply({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/modul-comment/reply?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        deleteMateri({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/modul/delete?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
    }
}
